import { useState } from "react";
import { categoryTabs, heatRank, posts } from "@/mocks/data";
import PostCard from "./PostCard";

const rankIcons = [
  "text-primary-600",
  "text-primary-500",
  "text-accent-600",
];

export default function FeedSection() {
  const [tab, setTab] = useState("综合");

  const filtered =
    tab === "综合" ? posts : posts.filter((p) => p.category === tab);

  return (
    <section id="latest" className="scroll-mt-20 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-8 lg:grid-cols-3">
          {/* left feed */}
          <div className="lg:col-span-2">
            <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
              <div>
                <h2 className="flex items-center gap-2 font-heading text-2xl font-black text-foreground-950">
                  <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                    <i className="ri-flashlight-line text-lg" />
                  </span>
                  最新事件速递
                </h2>
                <p className="mt-1 pl-11 text-sm text-foreground-500">
                  按发布时间持续更新，随手跟上每一件新料与反转。
                </p>
              </div>
              <a
                href="#faq"
                className="inline-flex w-fit items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-800"
              >
                进展订阅方式
                <i className="ri-arrow-right-line" />
              </a>
            </div>

            {/* segmented tabs */}
            <div className="mb-6 flex flex-wrap items-center gap-2 rounded-full border border-background-200 bg-background-50 p-1 md:w-fit">
              {categoryTabs.map((c) => (
                <button
                  key={c}
                  onClick={() => setTab(c)}
                  className={
                    tab === c
                      ? "inline-flex whitespace-nowrap items-center gap-1 rounded-full bg-primary-500 px-4 py-1.5 text-sm font-medium text-background-50 transition-colors"
                      : "inline-flex whitespace-nowrap items-center gap-1 rounded-full px-4 py-1.5 text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  }
                >
                  {c}
                </button>
              ))}
            </div>

            <div className="grid gap-5 sm:grid-cols-2">
              {filtered.map((p) => (
                <PostCard key={p.id} post={p} />
              ))}
            </div>

            <div className="mt-8 flex justify-center">
              <a
                href="#rank"
                className="inline-flex whitespace-nowrap items-center gap-2 rounded-md border border-background-300 bg-background-50 px-6 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                已加载当前 8 起 · 前往热榜查看更多
                <i className="ri-arrow-down-line" />
              </a>
            </div>
          </div>

          {/* right heat rank */}
          <aside id="rank" className="scroll-mt-24">
            <div className="sticky top-24 overflow-hidden rounded-xl border border-background-200 bg-background-50">
              <div className="flex items-center justify-between border-b border-background-200 bg-secondary-100 px-5 py-3.5">
                <h2 className="flex items-center gap-2 font-heading text-lg font-black text-foreground-950">
                  <i className="ri-fire-fill text-xl text-primary-600" />
                  实时热榜追踪
                </h2>
                <span className="inline-flex items-center gap-1 text-xs text-secondary-700">
                  <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-primary-500" />
                  5 分钟更新
                </span>
              </div>
              <ol className="divide-y divide-background-100 px-3 py-2">
                {heatRank.map((h, i) => (
                  <li key={h.title}>
                    <a
                      href="#latest"
                      className="group flex items-start gap-3 rounded-lg px-2 py-2.5 transition-colors hover:bg-background-100"
                    >
                      <span
                        className={
                          "mt-0.5 w-5 shrink-0 text-center font-heading text-lg font-black " +
                          (rankIcons[i] ?? "text-foreground-400")
                        }
                      >
                        {i + 1}
                      </span>
                      <span className="min-w-0">
                        <span className="line-clamp-2 text-sm font-medium leading-snug text-foreground-900 group-hover:text-primary-700">
                          {h.title}
                        </span>
                        <span className="mt-1 flex items-center gap-2 text-xs text-foreground-400">
                          <span className="inline-flex items-center gap-0.5 text-primary-600">
                            <i className="ri-hotspot-line" /> {h.heat}
                          </span>
                          <span>{h.status}</span>
                        </span>
                      </span>
                    </a>
                  </li>
                ))}
              </ol>
              <div className="border-t border-background-200 px-5 py-3 text-center">
                <a
                  href="#about"
                  className="text-xs text-foreground-500 hover:text-primary-700"
                >
                  热度为公开数据估算，点击查看统计口径 →
                </a>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}